import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { MsalProvider } from "@azure/msal-react";
import {
  InteractionRequiredAuthError,
  PublicClientApplication,
} from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./api/queryClient";
import { AuthWrapper } from "./authWrapper";
import { RouterProvider } from "./routes";

export const msalInstance = new PublicClientApplication(msalConfig);

await msalInstance.initialize();

const activeAccount = msalInstance.getActiveAccount();

if (!activeAccount && msalInstance.getAllAccounts().length > 0) {
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
} else if (activeAccount !== null) {
  msalInstance.setActiveAccount(activeAccount);
}

msalInstance.addEventCallback((e) => {
  if (e.error && !(e.error instanceof InteractionRequiredAuthError)) {
    console.error("MSAL Error:", e.error);
  }
});

const ele = document.getElementById("root");

if (ele) {
  const root = ReactDOM.createRoot(ele);

  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <AuthWrapper>
          <QueryClientProvider client={queryClient}>
            <RouterProvider />
          </QueryClientProvider>
        </AuthWrapper>
      </MsalProvider>
    </React.StrictMode>
  );
}
